import React, { FunctionComponent } from 'react';
import { fileInfos } from './SmallOrderTable';
import Modal from 'react-responsive-modal';
import { TFunction, withTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  fileInfos?: fileInfos;
  t?: TFunction;
  onContinue: () => void;
  onCancel: () => void;
}

const ModalDimensionsNotSave: FunctionComponent<Props> = ({ t, show, fileInfos, onCancel, onContinue }) => {

  return (
    <>
      <Modal open={show} onClose={onCancel} center>
        <div>
          <span className="font20">
          {t?.('text_not_save')}
          </span><br />
          <span className="font18 bold">
            {
              t?.('question')
                .replace('|width|', fileInfos?.dimensionsCM?.largeur?.toString() ?? '')
                .replace('|height|', fileInfos?.dimensionsCM?.hauteur?.toString() ?? '')
            }
          </span>
          <div className="d-flex justify-content-end mt-4">
            <button
              className="btn btn-dt-secondary mr-4"
              onClick={onCancel}
            >
              {t?.('no')}
              </button>
            <button
              className="btn btn-dt-primary"
              onClick={onContinue}
            >
              {t?.('continue')}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default withTranslation('modalDimensions')(ModalDimensionsNotSave);
